<template>
   <div class="row yo-max-w yo-padding-bottom-xs yo-padding-top-xxs">
      <div class="col yo-margin-top-s" :class="($teras.app.device=='mobile') ? 's11 offset-sm' : 's11m offset-ss'">
         <div class="col s12 yo-color-primary yo-margin-bottom-s">
            <h2>SYLLABUS COURSE</h2>
            <p class="yo-text-n yo-color-primary-light">A top quality EFLM Revision Course designed to increase the knowledge and exam confidence for postgraduate students</p>
         </div>

         <!--<div class="col s10 offset-s1 yo-align-center yo-margin-top-s yo-margin-bottom-s">
            <p class="yo-text-s yo-padding-bottom-xs">
               THE EFLM SYLLABUS COURSE IS MANTAINED THANKS TO THE UNCONDITIONAL SUPPORT OF
            </p>
            <div class="col s12 logo-sponsor">
               <img src="/site/images/ortho-logo.png" alt="ORTHO" width="250" height="65" />
            </div>
         </div>-->

         <div class="col s12 yo-margin-top-s yo-margin-bottom">
            <p class="yo-padding-bottom">
               This major EFLM educational resource has been designed by the EFLM Task Group for Syllabus Course to 
               support the harmonization of postgraduate education of Specialists in Laboratory Medicine in Europe.
            </p>
            The EFLM Syllabus Course consists of more than 40 modules and over 300 lectures of 45’ each covering the four 
            main sections of the <a href="https://www.eflm.eu/site/api/download/1435-1.CCLM2018_Syllabus.pdf/publications/The%20European%20Federation%20of%20Clinical%20Chemistry%20and%20Laboratory%20Medicine%20syllabus%20for%20postgraduate%20education%20and%20training%20for%20Specialists%20in%20Laboratory%20Medicine:%20version%205%20%E2%80%93%202018" target="_blank">EFLM Syllabus</a>:
            <ul style="margin-block-start: 0;">
               <li>the generic knowledge, skills and competencies</li>
               <li>the specialist knowledge within each discipline</li>
               <li>the skills required to carry out research, development and audit</li>
               <li>the leadership skills and competencies</li>
            </ul>

            <p class="yo-padding-bottom-m">
               Each lecture provides 3-5 questions in the end for a quick check of the understanding of the topic. The aim of the course is purely educational and not to provide a degree or a certificate of attendance.<br />
            </p>
         </div>

         <div class="col s12 yo-margin-top-xs yo-margin-bottom-xs syllabus-button information-course">
            <div class="col s12" style="padding: 24px 16px;">
               <a href="https://www.eflm.eu/upload/docs/EFLM-Syllabus-Course-brochure-latest-version.pdf" target="_blank">
                  <h4>Detailed Information about the Course</h4>
               </a>
            </div>
         </div>
         <div class="col s12 yo-margin-top-xs yo-margin-bottom-xs syllabus-button access-course">
            <div class="col s12" style="padding: 24px 16px;">
               <table class="yo-width-full">
                  <tbody>
                     <tr>
                        <td class="yo-width-fit">
                           <a :href="$teras.utente.id!=undefined ? 'https://www.eflm-elearning.eu/platform/event/22999/autologin/'+$aes.encode($teras.utente.id, $teras.utente.password) : 'https://www.eflm-elearning.eu/platform/event/22999'" target="_blank">
                              <h4>Access the Course</h4>
                           </a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data(){
      return{
         lezioniFistHalf: [],
         lezioniSecondHalf: [],
         indexSecondHalf: -1
      }
   },
   async created(){
      document.title= "EFLM Academy Site | Syllabus Course"
      this.$teras.loaded= false
      /*if(this.$teras.lezioniSyllabus.length==0){
         await this.$axios.query('FetchAll', 
            `SELECT id, REGEXP_REPLACE(titolo, '^MODULE [0-9]*:', '') AS titolo
            FROM lezione 
            WHERE id>0 AND evento= (SELECT id FROM evento WHERE tipo= 4) AND tipo= 0
            ORDER BY peso`, {}, this.$teras, 'lezioniSyllabus')
      }*/
      /*this.indexSecondHalf= Math.floor(this.$teras.lezioniSyllabus.length/2)
      this.lezioniFistHalf= this.$teras.lezioniSyllabus.slice(0, this.indexSecondHalf)
      this.lezioniSecondHalf= this.$teras.lezioniSyllabus.slice(this.indexSecondHalf)
      console.log(this.lezioniFistHalf)
      console.log(this.lezioniSecondHalf)*/
      this.$teras.loaded= true
   }
}
</script>